import { Paths } from 'src/constants/paths'

export const getExplanationRoomDocuSignReturnUrl = () => {
  return [import.meta.env.VITE_WEB_DOMAIN, Paths.DocuSignRedirect].join('')
}
